import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Row, Col, Container } from "reactstrap";
import { HeaderTitle, PrimaryButton } from "../../../utils/budget-tool-specific";
import { useParams } from "react-router-dom";
import FlightExperimentalGuideInput from "./flight-experimental-guide-input";

const FlightsExperimentalEdit = (props) => {
    let { experience } = useParams();
    if (experience === undefined) {
        window.history.replaceState(null, "", "/budget-app/flights-experimental");
    }

    const backToGuideList = () => {
        window.location = "/budget-app/flights-experimental";
    }

    return(
        <PageContainer>
            <Row>
                <Col>
                    <HeaderTitle>
                        Flights (exp.) 🚀
                    </HeaderTitle>
                </Col>
                {!props.client &&
                <Col style={{textAlign: "right"}}>
                    <PrimaryButton style={{marginTop: "30px", marginRight: "30px"}}
                                onClick={(x) => backToGuideList()}> Back to Guide List</PrimaryButton>
                </Col>
                }
            </Row>
            <div style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeaa7",
                borderRadius: "8px",
                padding: "15px",
                margin: "15px",
                marginBottom: "20px"
            }}>
                <p style={{margin: "0", fontSize: "14px", color: "#856404"}}>
                    <strong>🧪 Experimental Feature:</strong> You can switch between FlightApi.io and Amadeus APIs below.
                </p>
            </div>
            <FlightExperimentalGuideInput id={experience} client={props.client}/>
        </PageContainer>
    )
}

export default FlightsExperimentalEdit;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;

const IconRow = styled(Row)`
    display: contents;
`

const StyledCol = styled(Col)`
    text-align: center;
    margin-bottom: 50px;
`
const StyledContainer = styled(Container)`
    padding: 32px;
`